// 核心数据-详情页 用餐方式-详情页 用餐时段-详情页
import {
  analysisStatisticOrderbasedetail,
  analysisStatisticEattypedetail,
  analysisStatisticTimetypedetail,
} from "@/api/hb-dataStatistics/revenueDailyReport.js";

function getTime(val) {
  if (val) {
    return val.slice(0, 10);
  }
}

const revenueDaily = {
  state: {
    // 当前选择的日报数据
    currentDailyReportData: {},
    // 当前时间
    currentDailyReportTime: "",
    // 当前页面 inner 选项（不统计内部员工订单）
    currentPageInnerUser: true,
    // 新增：当前页面不统计 POS 订单
    currentPageNotPosOrder: true,
    // 当前页面出餐方式
    currentPageEatType: "IN_SITE",
    // 当前页面用餐时段
    currentPageTimeType: "1",
    // 核心数据
    dailyBaseData: {},
    // 用餐方式
    dailyConutWayData: {},
    // 用餐时段
    dailyConutTimesData: {},
  },

  actions: {
    getDailyBaseData({ commit, state }) {
      const params = {
        siteId: state.currentDailyReportData.siteId, // 店铺ID
        timeStr: getTime(state.currentDailyReportTime), // yyyy-mm-dd
        innerUser: state.currentPageInnerUser ? 1 : 0, // 0全部 1客户订单
        notPosOrder: state.currentPageNotPosOrder ? 1 : 0, // 新增：0全部 1过滤POS
      };
      return new Promise((resolve, reject) => {
        analysisStatisticOrderbasedetail(params)
          .then((res) => {
            const data = res.data.data || {};
            commit("SET_DAILY_BASE_DATA", data);
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    getDailyConutWayData({ commit, state }) {
      const params = {
        siteId: state.currentDailyReportData.siteId, // 店铺ID
        timeStr: getTime(state.currentDailyReportTime), // yyyy-mm-dd
        eatType: state.currentPageEatType,
        innerUser: state.currentPageInnerUser ? 1 : 0, // 0全部 1客户订单
        notPosOrder: state.currentPageNotPosOrder ? 1 : 0, // 新增
      };
      return new Promise((resolve, reject) => { 
        analysisStatisticEattypedetail(params)
          .then((res) => {
            const data = res.data.data || {};
            commit("SET_DAILY_CONUT_WAY_DATA", data);
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    getDailyConutTimesData({ commit, state }) {
      const params = {
        siteId: state.currentDailyReportData.siteId, // 店铺ID
        timeStr: getTime(state.currentDailyReportTime), // yyyy-mm-dd
        timeType: state.currentPageTimeType,
        innerUser: state.currentPageInnerUser ? 1 : 0, // 0全部 1客户订单
        notPosOrder: state.currentPageNotPosOrder ? 1 : 0, // 新增
      };
      return new Promise((resolve, reject) => {
        analysisStatisticTimetypedetail(params)
          .then((res) => {
            const data = res.data.data || {};
            commit("SET_DAILY_CONUT_TIMES_DATA", data);
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    refreshAllDailyDetail({ dispatch }, params) {
      return Promise.all([
        dispatch("getDailyBaseData", params),
        dispatch("getDailyConutWayData", params),
        dispatch("getDailyConutTimesData", params),
      ]);
    },
  },

  mutations: {
    SET_CURRENT_DAILY_REPORT_DATA: (state, val) => {
      state.currentDailyReportData = val;
    },
    SET_CURRENT_DAILY_REPORT_TIME: (state, time) => {
      state.currentDailyReportTime = time;
    },
    SET_CURRENT_PAGE_INNER_USER: (state, val) => {
      state.currentPageInnerUser = !!val;
    },
    // 新增：不统计 POS 订单
    SET_CURRENT_PAGE_NOT_POS_ORDER: (state, val) => {
      state.currentPageNotPosOrder = !!val;
    },
    SET_CURRENT_PAGE_TIME_TYPE: (state, val) => {
      state.currentPageTimeType = val;
    },
    SET_CURRENT_PAGE_EAT_TYPE: (state, val) => {
      state.currentPageEatType = val;
    },
    SET_DAILY_BASE_DATA(state, data) {
      state.dailyBaseData = data;
    },
    SET_DAILY_CONUT_WAY_DATA(state, data) {
      state.dailyConutWayData = data;
    },
    SET_DAILY_CONUT_TIMES_DATA(state, data) {
      state.dailyConutTimesData = data;
    },
  },
};

export default revenueDaily;
